import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

export default function RegisterPincodeGate() {
  const navigate = useNavigate();
  const [pincode, setPincode] = useState("");
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const handleBack = () => {
    navigate("/");
  };

  const handleCheckPincode = async () => {
    setError("");
    setResult(null);

    const cleaned = pincode.trim();
    if (!/^\d{6}$/.test(cleaned)) {
      setError("Please enter a valid 6-digit pincode.");
      return;
    }

    try {
      setChecking(true);
      const res = await api.CheckPincode(cleaned);
      const row = res?.PincodeStatus?.Table?.[0];

      if (!row) {
        setError("Unable to validate pincode. Please try again.");
        return;
      }

      const status = (row.Status || "").trim();
      const message = row.Message || "";
      const foodTypesStatus = res?.PincodeStatus?.Table1 || [];
      
      const normalized = {
        pincode: row.Pincode || cleaned,
        status,
        message,
        foodTypesStatus,
      };

      setPincode(normalized.pincode);
      setResult(normalized);
      sessionStorage.setItem("registrationPincodeGate", JSON.stringify(normalized));
      
      // Navigate directly to food type status page
      navigate("/register/pincode/status", {
        state: { result: normalized },
      });
    } catch (err) {
      console.error("CheckPincode failed:", err);
      setError("Server error while checking pincode. Please try again.");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] px-4 relative">
      <button
        onClick={handleBack}
        className="absolute flex items-center gap-2 font-semibold text-gray-600 transition top-4 left-4 hover:text-red-700"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"></path>
        </svg>
        <span>Back</span>
      </button>
      
      <div className="w-full max-w-2xl p-6 bg-white border-t-4 border-red-500 shadow-xl rounded-2xl sm:p-8">
        <h1 className="text-2xl font-bold text-center text-red-600 sm:text-3xl">Before Sign Up</h1>
        <p className="mt-3 text-center text-gray-700">
          Enter your pincode to check delivery availability in your area before creating your account.
        </p>

        <div className="mt-6 space-y-3">
          <input
            type="tel"
            inputMode="numeric"
            maxLength={6}
            value={pincode}
            onChange={(e) => setPincode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            placeholder="Enter 6-digit Pincode"
            className="w-full p-3 text-center border rounded-md"
          />

          <button
            type="button"
            onClick={handleCheckPincode}
            disabled={checking}
            className="w-full py-3 font-bold text-white bg-red-500 rounded-lg hover:bg-red-600 disabled:opacity-50"
          >
            {checking ? "Checking..." : "Check Pincode"}
          </button>
        </div>

        {error && <p className="mt-3 text-sm text-center text-red-500">{error}</p>}
      </div>
    </div>
  );
}
